import { render, staticRenderFns } from "./a-copy.vue?vue&type=template&id=6e6c13ad&scoped=true"
import script from "./a-copy.vue?vue&type=script&lang=js"
export * from "./a-copy.vue?vue&type=script&lang=js"
import style0 from "./a-copy.vue?vue&type=style&index=0&id=6e6c13ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c13ad",
  null
  
)

export default component.exports